import React from 'react';
import Index from './pages/Index';
import Create from './pages/Create';
import Edit from './pages/Edit';
import { AppRouteProps } from '~/routes';

export default function PublicAgencyRoutes(): readonly AppRouteProps[] {
  const routes: readonly AppRouteProps[] = [
    {path: '/organization', component: Index, isProtected: true, permissions: ['organization_index']},
    {path: '/organization/create', component: Create, isProtected: true, permissions: ['organization_create']},
    {path: '/organization/edit/:id', component: Edit, isProtected: true, permissions: ['organization_edit']},

  ];

  return routes;
}
